import React from 'react';

import Typography from 'components-new/typography/typography';
import Divider from 'components-new/divider/divider';
import RadioButtonGroup from 'components/radio-button-group/radio-button-group';
import useRedirect from 'hooks/use-redirect';

import { createLocale } from 'locales';

import WeekPicker from './week-picker';

const locales = createLocale('freelancerAvailabilityLocales');
const globalLocalize = createLocale('global');

const Header: React.FC = () => {
  const redirect = useRedirect();

  const onMonthlyViewClicked = () => {
    redirect('/freelancer/agenda');
  };

  return (
    <div className="flex flex-col gap-y-5 mt-4">
      <Typography as="h3" variant="heading-1" className="text-primary-400">
        {globalLocalize('available')}
      </Typography>
      <Divider orientation="horizontal" className="w-full h-1" />
      <RadioButtonGroup
        elements={[
          {
            active: true,
            id: '1',
            location: 'start',
            title: locales('perWeek'),
          },
          {
            active: false,
            id: '2',
            location: 'end',
            onClick: onMonthlyViewClicked,
            title: locales('perMonth'),
          },
        ]}
        className="w-fit self-center"
      />
      <WeekPicker className="self-center" />
    </div>
  );
};

export default Header;
